// extracted by mini-css-extract-plugin
export default {"flexContainer":"styles_flexContainer__dfDpd"};